import { useEffect, useState } from "react";
import useOptions from "../hooks/useOptions.js";
import useOptionsABSelect from "../hooks/useOptionsABSelect.js";

function GetMasterData() {
  //   const usersStore = useSelector((state) => state.userVerificationCandidate);
  //   const { userData } = usersStore;

  /////////////getting master data

  const [genderOptions, setGenderOptions] = useState({});
  const {
    fetchData: a_Fetch,
    data: a_Data,
    loading: a_Loading,
    error: a_Error,
  } = useOptions("gender");

  useEffect(() => {
    if (a_Data) {
      setGenderOptions(a_Data);
    } else {
      setGenderOptions({});
    }
  }, [a_Data]);

  ////////////////////////////////////////////////////////////////////////

  const [prefixOptions, setPrefixOptions] = useState({});
  const {
    fetchData: b_Fetch,
    data: b_Data,
    loading: b_Loading,
    error: b_Error,
  } = useOptions("profile_prefix");

  useEffect(() => {
    if (b_Data) {
      setPrefixOptions(b_Data);
    } else {
      setPrefixOptions([]);
    }
  }, [b_Data]);

  const [maritalOptions, setMaritalOptions] = useState({});
  const {
    fetchData: c_Fetch,
    data: c_Data,
    loading: c_Loading,
    error: c_Error,
  } = useOptions("marital_status");

  useEffect(() => {
    if (c_Data) {
      setMaritalOptions(c_Data);
    } else {
      setMaritalOptions([]);
    }
  }, [c_Data]);

  const [birthCountryOptions, setBirthCountryOptions] = useState({});

  const {
    fetchData: d_Fetch,
    data: d_Data,
    loading: d_Loading,
    error: d_Error,
  } = useOptions("country_list");

  useEffect(() => {
    if (d_Data) {
      setBirthCountryOptions(d_Data);
    } else {
      setBirthCountryOptions([]);
    }
  }, [d_Data]);

  //////////////////////////////////////////////////////////////////////////

  const [degreeOptions, setDegreeOptions] = useState({});

  const {
    fetchData: e_Fetch,
    data: e_Data,
    loading: e_Loading,
    error: e_Error,
  } = useOptionsABSelect("degree");

  useEffect(() => {
    if (e_Data) {
      setDegreeOptions(e_Data);
    } else {
      setDegreeOptions([]);
    }
  }, [e_Data]);

  //////////////////////////////////////////////////////////////////////////

  const [veridficationCourseNameOptions, setVeridficationCourseNameOptions] =
    useState({});

  const {
    fetchData: f_Fetch,
    data: f_Data,
    loading: f_Loading,
    error: f_Error,
  } = useOptionsABSelect("verification_course_name");

  useEffect(() => {
    if (f_Data) {
      setVeridficationCourseNameOptions(f_Data);
    } else {
      setVeridficationCourseNameOptions([]);
    }
  }, [f_Data]);

  //////////////////////////////////////////////////////////////////////////

  const [qualificationOptions, setQualificationOptions] = useState({});

  const {
    fetchData: g_Fetch,
    data: g_Data,
    loading: g_Loading,
    error: g_Error,
  } = useOptionsABSelect("qualification");

  useEffect(() => {
    if (g_Data) {
      setQualificationOptions(g_Data);
    } else {
      setQualificationOptions([]);
    }
  }, [g_Data]);

  //////////////////////////////////////////////////////////////////////////////////

  // const [stateOptions, setStateOptions] = useState({});
  //////////////////////////////////////////////////////////////////////////

  // const {
  //   fetchData: h_Fetch,
  //   data: h_Data,
  //   loading: h_Loading,
  //   error: h_Error,
  // } = useOptionsABSelect("state_list");

  // useEffect(() => {
  //   if (h_Data) {
  //     setStateOptions(h_Data);
  //   } else {
  //     setStateOptions([]);
  //   }
  // }, [h_Data]);
  //////////////////////////////////////////////////////////////////////////

  const [modeOfQualificationOptions, setModeOfQualificationOptions] = useState(
    {}
  );

  const {
    fetchData: i_Fetch,
    data: i_Data,
    loading: i_Loading,
    error: i_Error,
  } = useOptionsABSelect("mode_of_qualification");

  useEffect(() => {
    if (i_Data) {
      setModeOfQualificationOptions(i_Data);
    } else {
      setModeOfQualificationOptions([]);
    }
  }, [i_Data]);

  ////////////////////////////////////////////////////////////////////////////////////

  const [bridgeLocation, setBridgeLocation] = useState({});

  const {
    fetchData: li_Fetch,
    data: li_Data,
    loading: li_Loading,
    error: li_Error,
  } = useOptionsABSelect("location");

  useEffect(() => {
    if (li_Data) {
      setBridgeLocation(li_Data);
    } else {
      setBridgeLocation([]);
    }
  }, [li_Data]);
  ///////////////////////////////////////////////////////////////////////////////////////
  const [currencyOptions, setCurrencyOptions] = useState({});

  const {
    fetchData: j_Fetch,
    data: j_Data,
    loading: j_Loading,
    error: j_Error,
  } = useOptionsABSelect("currency");

  useEffect(() => {
    if (j_Data) {
      setCurrencyOptions(j_Data);
    } else {
      setCurrencyOptions([]);
    }
  }, [j_Data]);

  const [bestTimeToReachOptions, setBestTimeToReachOtions] = useState({});
  const {
    fetchData: k_Fetch,
    data: k_Data,
    loading: k_Loading,
    error: k_Error,
  } = useOptionsABSelect("best_time_to_reach");
  useEffect(() => {
    if (k_Data) {
      setBestTimeToReachOtions(k_Data);
    } else {
      setBestTimeToReachOtions([]);
    }
  }, [k_Data]);

  /////////////////////////////////////////////////////////////

  const [countryOptions, setCountryOptions] = useState({});

  const {
    fetchData: l_Fetch,
    data: l_Data,
    loading: l_Loading,
    error: l_Error,
  } = useOptions("country_list");

  useEffect(() => {
    if (l_Data) {
      setCountryOptions(l_Data);
    } else {
      setCountryOptions([]);
    }
  }, [l_Data]);

  //////////////////////////////////////////////////////////

  const [industryOptions, setIndustryOptions] = useState({});

  const {
    fetchData: m_Fetch,
    data: m_Data,
    loading: m_Loading,
    error: m_Error,
  } = useOptionsABSelect("industry_type");

  useEffect(() => {
    if (m_Data) {
      setIndustryOptions(m_Data);
    } else {
      setIndustryOptions([]);
    }
  }, [m_Data]);

  ///////////////////////////////////////////////////////////////////

  const [countryCodeOptions, setCountryCodeOptions] = useState([]);

  const {
    fetchData: n_Fetch,
    data: n_Data,
    loading: n_Loading,
    error: n_Error,
  } = useOptionsABSelect("country_codes");

  useEffect(() => {
    if (n_Data) {
      setCountryCodeOptions(n_Data);
    } else {
      setCountryCodeOptions([]);
    }
  }, [n_Data]);


  //////////////////////////////////////////////////////////////////////////
  const [stateOptionspv, setStateOptionspv] = useState({});
  const {
    fetchData: o_Fetch,
    data: o_Data,
    loading: o_Loading,
    error: o_Error,
  } = useOptions("state_list");

  useEffect(() => {
    if (o_Data) {
      setStateOptionspv(o_Data);
    } else {
      setStateOptionspv([]);
    }
  }, [o_Data]);

  //////////////////////////////////////////////////////////////////////////

  const [relationOptionspv, setRelationOptionspv] = useState({});
  const {
    fetchData: p_Fetch,
    data: p_Data,
    loading: p_Loading,
    error: p_Error,
  } = useOptions("relation");

  useEffect(() => {
    if (o_Data) {
      setRelationOptionspv(p_Data);
    } else {
      setRelationOptionspv([]);
    }
  }, [o_Data]);

    //////////////////////////////////////////////////////////////////////////
    const [cityOptions, setCityOptions] = useState({});
    const {
      fetchData: r_Fetch,
      data: r_Data,
      loading: r_Loading,
      error: r_Error,
    } = useOptions("city_list");
  
    useEffect(() => {
      if (r_Data) {
        setCityOptions(r_Data);
      } else {
        setCityOptions({});
      }
    }, [r_Data]);
    //////////////////////////////////////////////////////////////////////

    const [digiLockerUniversityList, setDigiLockerUniversityList] = useState({});
    // const {
    //   fetchData: q_Fetch,
    //   data: q_Data,
    //   loading: q_Loading,
    //   error: q_Error,
    // } = useOptionsABSelect("master_ts_university");
  
    // useEffect(() => {
    //   if (q_Data) {
    //     setDigiLockerUniversityList(q_Data);
    //   } else {
    //     setDigiLockerUniversityList([]);
    //   }
    // }, [q_Data]);

    // education states
    const [stateOptionsEducation, setStateOptionsEducation] = useState({});
    const {
      fetchData: s_Fetch,
      data: s_Data,
      loading: s_Loading,
      error: s_Error,
    } = useOptions("education_states");
  
    useEffect(() => {
      if (s_Data) {
        setStateOptionsEducation(s_Data);
      } else {
        setStateOptionsEducation([]);
      }
    }, [s_Data]);

  return {
    genderOptions,
    prefixOptions,
    maritalOptions,
    birthCountryOptions,
    degreeOptions,
    veridficationCourseNameOptions,
    qualificationOptions,
    // stateOptions,
    stateOptionspv,
    relationOptionspv,
    currencyOptions,
    modeOfQualificationOptions,
    bestTimeToReachOptions,
    countryOptions,
    industryOptions,
    countryCodeOptions,
    bridgeLocation,
    digiLockerUniversityList,
    cityOptions,
    stateOptionsEducation
  };
}
export default GetMasterData;
